import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa6'
import ModalUpdate from './ModalUpdate'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { BsPencilSquare } from 'react-icons/bs'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import styled from 'styled-components'
import { listSettingCostCenterAPI } from '../../../services/setting/cost-center'

export default function SettingCostCenterPage() {
  const totalLimits = 20
  const [page, setPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRows, setTotalRows] = useState(2)
  const [dataTable, setDataTable] = useState([])
  const [showModal, setShowModal] = useState({ isShow: false, data: null })
  const [bodyFilter, setBodyFilter] = useState()
  useEffect(() => {
    const body = {
      page: 1
    }
    fnGetData(body)
  }, [])

  const fnGetData = async (body) => {
    setBodyFilter(body)
    setIsLoading(true)
    const resp = await listSettingCostCenterAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRows(resp.totalRows)
    } else {
      setTotalRows(0)
      setDataTable([])
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      page: 1,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      page: 1,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>Cost Center</TextNavTitle>
      </NavTitle>
      <CardCustom className="d-flex justify-content-between">
        <div>
          <div className="p-3">
            <Row>
              <Col md={4} className="my-auto small">
                <label>Total: {totalRows} </label>
              </Col>
              <Col md={8}>
                <BoxFilter className="justify-content-end">
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <Button
                    className="px-4 "
                    onClick={() => {
                      setShowModal({ isShow: true, data: null })
                    }}
                  >
                    <FaPlus className="me-2" />
                    New Cost Center
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">Number</th>
                <th className="fw-normal">Group Name</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Cost Center EN</th>
                <th className="fw-normal ">Cost Center TH</th>
                <th className="text-center fw-normal">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={7} rowSpan={6} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => {
                  return (
                    <tr className="font-small-2 align-middle" key={i}>
                      <td> {page * totalLimits - totalLimits + i + 1}</td>

                      <td className="">{d.costNumber}</td>
                      <td className="">{d.costGroupName}</td>
                      <td className="">{d.costName}</td>
                      <td className="">{d.costNameEn}</td>

                      <td className="">{d.costNameTh}</td>

                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="light"
                          className="text-primary"
                          onClick={() => {
                            setShowModal({ isShow: true, data: d })
                          }}
                        >
                          <BsPencilSquare />
                        </Button>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr className="font-small-2 align-middle">
                  <td className="text-center" colSpan={7}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showModal.isShow && (
        <ModalUpdate
          data={showModal.data}
          fnGetData={() => {
            const body = {
              page: 1
            }
            setPage(1)
            fnGetData(body)
          }}
          onCancel={() => setShowModal({ isShow: false, data: null })}
          open={showModal.isShow}
        />
      )}
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }

  .btn-new {
    flex: 0 0 150px;
  }
`
